import { GetToSStatusParams, GetToSStatusResponse } from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { RequestType, web3Api } from 'store/queries';
import { createQuerySelectors } from 'store/utils/createQuerySelectors';
import { createQueryFnWithErrorHandler } from 'store/utils/createQueryFnWithErrorHandler';

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be reflected there as well.
export const {
  endpoints: { fetchToSStatus },
  useFetchToSStatusQuery,
  useLazyFetchToSStatusQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchToSStatus: build.query<GetToSStatusResponse, GetToSStatusParams>({
      providesTags: [RequestType.ToSStatus],
      queryFn: createQueryFnWithErrorHandler({
        queryFn: async params => {
          const api = MultiService.getService().getAccountingGateway();

          const data = await api.getToSStatus(params);

          return { data };
        },
      }),
    }),
  }),
  overrideExisting: true,
});

const tosStatusFallback: GetToSStatusResponse = {
  tosAccepted: false,
};

export const {
  selectDataWithFallbackCachedByParams: selectToSStatus,
  selectLoadingCachedByParams: selectToSStatusLoading,
  selectStateCachedByParams: selectToSStatusState,
} = createQuerySelectors({
  endpoint: fetchToSStatus,
  fallback: tosStatusFallback,
});
